import { apiUrl } from '../api/config'

interface CallApiProps {
  path: string
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE'
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any
  token?: string
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function callApi<T = any>({ path, method = 'POST', body, token }: CallApiProps): Promise<{ isOk: boolean; data?: T }> {
  try {
    const res = await fetch(`${apiUrl}${path}`, {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` })
      },
      ...(body && { body: JSON.stringify(body) })
    })

    const responseContentType = res.headers.get('content-type')
    const responseIsJson = responseContentType && responseContentType.indexOf('application/json') !== -1

    if (!res.ok || res.status >= 400) {
      return { isOk: false, data: responseIsJson ? await res.json() : await res.text() }
    }

    return { isOk: true, data: responseIsJson ? await res.json() : await res.text() }
  } catch (e) {
    console.error(e)
    return { isOk: false }
  }
}
